import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';

// ── Logo font picker (commented out — kept for future use) ──────────────────
// import { useEffect } from 'react';
// import { useLogoFont } from '../context/LogoFontContext';
//
// const FONTS = [
//   { label: 'Cinzel (Serif, Regal)',         value: 'Cinzel',              url: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700&display=swap' },
//   { label: 'Playfair Display (Classic)',     value: 'Playfair Display',    url: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&display=swap' },
//   { label: 'IM Fell English (Old-Style)',    value: 'IM Fell English',     url: 'https://fonts.googleapis.com/css2?family=IM+Fell+English:ital@0;1&display=swap' },
//   { label: 'Libre Baskerville (Newspaper)',  value: 'Libre Baskerville',   url: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@700&display=swap' },
//   { label: 'Merriweather (Warm Serif)',      value: 'Merriweather',        url: 'https://fonts.googleapis.com/css2?family=Merriweather:wght@700&display=swap' },
//   { label: 'Lora (Elegant Serif)',           value: 'Lora',                url: 'https://fonts.googleapis.com/css2?family=Lora:wght@700&display=swap' },
//   { label: 'Crimson Text (Literary)',        value: 'Crimson Text',        url: 'https://fonts.googleapis.com/css2?family=Crimson+Text:wght@600&display=swap' },
//   { label: 'Josefin Sans (Geometric)',       value: 'Josefin Sans',        url: 'https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@700&display=swap' },
//   { label: 'Raleway (Modern Sans)',          value: 'Raleway',             url: 'https://fonts.googleapis.com/css2?family=Raleway:wght@700&display=swap' },
//   { label: 'Montserrat (Clean Sans)',        value: 'Montserrat',          url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap' },
//   { label: 'Oswald (Condensed)',             value: 'Oswald',              url: 'https://fonts.googleapis.com/css2?family=Oswald:wght@700&display=swap' },
//   { label: 'Exo 2 (Techy)',                  value: 'Exo 2',               url: 'https://fonts.googleapis.com/css2?family=Exo+2:wght@700&display=swap' },
//   { label: 'Unbounded (Bold/Impact)',        value: 'Unbounded',           url: 'https://fonts.googleapis.com/css2?family=Unbounded:wght@700&display=swap' },
//   { label: 'Space Grotesk (Modern)',         value: 'Space Grotesk',       url: 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@700&display=swap' },
//   { label: 'Abril Fatface (Display)',        value: 'Abril Fatface',       url: 'https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap' },
//   { label: 'Bebas Neue (Tall/Bold)',         value: 'Bebas Neue',          url: 'https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap' },
//   { label: 'Righteous (Retro)',              value: 'Righteous',           url: 'https://fonts.googleapis.com/css2?family=Righteous&display=swap' },
//   { label: 'Pacifico (Handwritten)',         value: 'Pacifico',            url: 'https://fonts.googleapis.com/css2?family=Pacifico&display=swap' },
//   { label: 'Satisfy (Script)',               value: 'Satisfy',             url: 'https://fonts.googleapis.com/css2?family=Satisfy&display=swap' },
//   { label: 'Dancing Script (Casual Script)', value: 'Dancing Script',      url: 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap' },
// ];

// function LogoPreview({ font }) {
//   return (
//     <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center', gap: '0.1rem' }}>
//       <img src="/pieces/cburnett/wK.svg" alt="King"
//         style={{ width: 50, height: 50, filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.5))' }} />
//       <span style={{ fontFamily: `'${font}', serif`, fontSize: '2.2rem', fontWeight: 700,
//         color: '#fff', letterSpacing: '0.01em', lineHeight: 1, textShadow: '0 1px 4px rgba(0,0,0,0.4)' }}>
//         ChessFlashcards.org
//       </span>
//     </div>
//   );
// }
//
// function FontPicker({ value, onChange }) {
//   return (
//     <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6rem',
//       background: 'rgba(255,255,255,0.15)', borderRadius: 8, padding: '0.4rem 0.8rem', marginTop: '1.25rem' }}>
//       <label htmlFor="font-picker" style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.85rem', marginBottom: 0 }}>Font:</label>
//       <select id="font-picker" value={value} onChange={e => onChange(e.target.value)}
//         style={{ background: 'rgba(255,255,255,0.9)', border: 'none', borderRadius: 5,
//           padding: '0.25rem 0.5rem', fontSize: '0.85rem', cursor: 'pointer', minWidth: 220 }}>
//         {FONTS.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
//       </select>
//     </div>
//   );
// }
//
// function useLoadedFont(fontValue) {
//   useEffect(() => {
//     const font = FONTS.find(f => f.value === fontValue);
//     if (!font) return;
//     if (document.querySelector(`link[data-font="${fontValue}"]`)) return;
//     const link = document.createElement('link');
//     link.rel = 'stylesheet';
//     link.href = font.url;
//     link.setAttribute('data-font', fontValue);
//     document.head.appendChild(link);
//   }, [fontValue]);
// }
// ───────────────────────────────────────────────────────────────────────────────

const TESTIMONIALS = [
  {
    name: 'Sarah K.',
    title: 'Club Player, Rating 1420',
    quote:
      'I used to study tactics by replaying entire games from a book. Once I started building flashcard sets for the positions I kept getting wrong, my rating jumped 120 points in three months. The instant feedback loop is something no book can replicate.',
  },
  {
    name: 'Marcus T.',
    title: 'Junior Coach, U1800 Competitors',
    quote:
      'My students now create their own decks from their tournament losses. Reviewing those critical positions right after the game — and then again a week later — has made a dramatic difference in how they handle similar endings. I recommend this to every parent whose kid is serious about improving.',
  },
  {
    name: 'Priya R.',
    title: 'Adult Improver, Rating 1650',
    quote:
      'I travel a lot for work and can\'t always sit down at a board. Being able to pull up my flashcard deck on my phone and drill key positions during a layover has changed how I use downtime. I\'ve gone from forgetting patterns to recognizing them almost instantly.',
  },
  {
    name: 'David L.',
    title: 'Tournament Player, Rating 1900',
    quote:
      'The difference between a 1700 and a 1900 isn\'t raw calculation speed — it\'s pattern recognition. Chess Flashcards gave me a systematic way to build that library of patterns. I can now see ideas in my games that previously wouldn\'t even register as a possibility.',
  },
  {
    name: 'Anna-Marie F.',
    title: 'School Chess Team Captain',
    quote:
      'Our whole team uses it now. We share decks before tournaments so everyone is drilling the same endgame themes. It\'s turned what used to be solo study into something we do together, and our team results have never been better.',
  },
];

const BENEFITS = [
  {
    icon: '♟',
    heading: 'Pattern Recognition, Not Memorization',
    body:
      'Chess mastery is built on seeing familiar shapes on the board. Flashcards train your brain to recognize those shapes automatically — a fork, a back-rank mate, a Lucena position — so you spend your clock on deep calculation rather than re-discovering ideas you\'ve seen before.',
  },
  {
    icon: '🔁',
    heading: 'Spaced Repetition That Actually Sticks',
    body:
      'Reviewing a position once is helpful. Reviewing it at the exact moment you\'re about to forget it is transformational. Chess Flashcards lets you revisit critical positions at the right intervals so the pattern moves from short-term recall into deep long-term memory.',
  },
  {
    icon: '⚡',
    heading: 'Turn Mistakes Into Lessons',
    body:
      'Every blunder is a teaching moment you paid for — the question is whether you cash in. After a game, add the decisive position to your deck. When you encounter that same structure weeks later and instantly know the answer, you\'ll feel the investment pay off.',
  },
  {
    icon: '🎯',
    heading: 'Train Anywhere, In Any Spare Moment',
    body:
      'Unlike setting up a board or stepping through a database, flashcard review takes seconds to start and as long as you have. Five minutes before a round, ten minutes on the train, twenty minutes at lunch — small sessions compound into enormous long-term gains.',
  },
];

export default function WelcomePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  // const { font, setFont } = useLogoFont();
  // useLoadedFont(font);

  return (
    <div>
      {/* ── Hero ─────────────────────────────────────────────────────────── */}
      <div
        className="py-5 mb-5 text-white text-center"
        style={{
          background: 'linear-gradient(135deg, #1a3a5c 0%, #2e6da4 100%)',
          margin: '0 calc(-50vw + 50%)',
          padding: '4rem 1rem',
        }}
      >
        <div className="container">
          <div style={{ marginBottom: '1.25rem' }}>
            <Logo/>
          </div>
          {/*<div style={{ marginBottom: '1.25rem' }}>*/}
          {/*  <LogoPreview font={font} />*/}
          {/*  <FontPicker value={font} onChange={setFont} />*/}
          {/*</div>*/}
          <p className="lead mb-4" style={{ maxWidth: 600, margin: '0 auto 1.5rem' }}>
            The fastest way to build the pattern library that separates good players from great ones.
            Create a deck from your own games, drill the positions that matter, and watch your rating follow.
          </p>
          {user ? (
            <button
              className="btn btn-light btn-lg px-5"
              onClick={() => navigate('/dashboard')}
            >
              Go to My Cards →
            </button>
          ) : (
            <div className="d-flex gap-3 justify-content-center">
              <Link to="/register" className="btn btn-light btn-lg px-4">
                Get Started Free
              </Link>
              <Link to="/login" className="btn btn-outline-light btn-lg px-4">
                Log In
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* ── Why it works ─────────────────────────────────────────────────── */}
      <div className="container">
        <h2 className="text-center fw-bold mb-2">Why Chess Flashcards Work</h2>
        <p className="text-center text-muted mb-5" style={{ maxWidth: 560, margin: '0 auto 3rem' }}>
          Elite players don't just play more games — they study smarter.
          Here's what makes spaced-repetition flashcard training so effective.
        </p>

        <div className="row row-cols-1 row-cols-md-2 g-4 mb-5">
          {BENEFITS.map((b, i) => (
            <div className="col" key={i}>
              <div className="card h-100 shadow-sm border-0" style={{ borderLeft: '4px solid #2e6da4' }}>
                <div className="card-body p-4">
                  <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{b.icon}</div>
                  <h5 className="fw-bold mb-2">{b.heading}</h5>
                  <p className="text-muted mb-0" style={{ lineHeight: 1.6 }}>{b.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ── How it works ─────────────────────────────────────────────── */}
        <div
          className="rounded-3 p-5 mb-5 text-center"
          style={{ background: 'var(--bs-secondary-bg)' }}
        >
          <h2 className="fw-bold mb-4">How It Works</h2>
          <div className="row row-cols-1 row-cols-md-3 g-4">
            {[
              { step: '1', heading: 'Create a Card', body: 'Paste a FEN from any game or position. Add the problem question and the solution. The board renders automatically.' },
              { step: '2', heading: 'Build Your Deck', body: 'Collect positions from your own games, training material, or opening lines you want to ingrain. Organize by theme or difficulty.' },
              { step: '3', heading: 'Drill & Improve', body: 'Run Quiz Mode for focused solo practice, or generate a printable report to take to your club. Share decks with teammates.' },
            ].map(({ step, heading, body }) => (
              <div className="col" key={step}>
                <div
                  className="rounded-circle d-inline-flex align-items-center justify-content-center fw-bold text-white mb-3"
                  style={{ width: 48, height: 48, background: '#2e6da4', fontSize: '1.2rem' }}
                >
                  {step}
                </div>
                <h5 className="fw-bold mb-2">{heading}</h5>
                <p className="mb-0" style={{ color: 'var(--bs-body-color)' }}>{body}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── Testimonials ─────────────────────────────────────────────── */}
        <h2 className="text-center fw-bold mb-2">What Players Are Saying</h2>
        <p className="text-center text-muted mb-4">
          From club players to coaches — real results from real improvement.
        </p>

        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mb-5">
          {TESTIMONIALS.map((t, i) => (
            <div className="col" key={i}>
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body p-4 d-flex flex-column">
                  <div style={{ fontSize: '2rem', color: '#2e6da4', lineHeight: 1, marginBottom: '0.75rem' }}>
                    "
                  </div>
                  <p className="flex-grow-1 text-muted fst-italic mb-3" style={{ lineHeight: 1.65 }}>
                    {t.quote}
                  </p>
                  <div>
                    <div className="fw-semibold">{t.name}</div>
                    <div className="small text-muted">{t.title}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ── Bottom CTA ───────────────────────────────────────────────── */}
        <div className="text-center py-4 mb-4">
          <h3 className="fw-bold mb-3">Ready to level up your game?</h3>
          {user ? (
            <button
              className="btn btn-primary btn-lg px-5"
              onClick={() => navigate('/dashboard')}
            >
              Go to My Cards →
            </button>
          ) : (
            <div className="d-flex gap-3 justify-content-center">
              <Link to="/register" className="btn btn-primary btn-lg px-4">
                Create a Free Account
              </Link>
              <Link to="/login" className="btn btn-outline-secondary btn-lg px-4">
                Log In
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
